var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.customMessageActive)?_c('div',{staticClass:"cc-custom-message p-3"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.customMessage)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }